import { graphql } from "@/gql";

export const GET_PORT_QUERY = graphql(`
  query GetPort {
    port {
      name
      id
      center {
        latitude
        longitude
      }
      zoomLevel
      mapTmsUrl
      wharves {
        id
        name
      }
    }
  }
`);

export const DELETE_CAP_BEAM_INSPECTION_MUTATION = graphql(`
  mutation DeleteCapBeamInspection($id: ID!) {
    deleteCapBeamInspection(id: $id)
  }
`);

export const GET_CAP_BEAM_INSPECTIONS_QUERY = graphql(`
  query GetCapBeamInspections($id: ID!) {
    capBeam(id: $id) {
      id
      inspections {
        inspectionDate
        id
        steelCondition
        decays {
          depth
          width
          length
          span
          id
          location
        }
        inspectedBy {
          firstName
          lastName
        }
        structurallyInadequate
      }
    }
  }
`);

export const CREATE_CAP_BEAM_INSPECTION_MUTATION = graphql(`
  mutation CreateCapBeamInspection($input: CapBeamInspectionInput!) {
    createCapBeamInspection(input: $input) {
      id
      inspectionDate
      steelCondition
      decays {
        width
        depth
        length
        span
        location
      }
      inspectedBy {
        firstName
        lastName
      }
      structurallyInadequate
    }
  }
`);

export const CREATE_PILE_INSPECTION_MUTATION = graphql(`
  mutation CreatePileInspection($input: PileInspectionInput!) {
    createPileInspection(input: $input) {
      id
      inspectionDate
      wastedDiameter
      seabedDiameter
      condition
      jacketCondition
      inspectedBy {
        firstName
        lastName
      }
    }
  }
`);

export const GET_PILE_INSPECTIONS_QUERY = graphql(`
  query GetPileInspections($id: ID!) {
    pile(id: $id) {
      id
      inspections {
        inspectionDate
        id
        condition
        jacketCondition
        seabedDiameter
        wastedDiameter
        inspectedBy {
          firstName
          lastName
        }
      }
    }
  }
`);

export const GET_CAP_BEAM_PROPERTIES_QUERY = graphql(`
  query GetCapBeamProperties($id: ID!) {
    capBeam(id: $id) {
      id
      properties {
        id
        appointedOn
        breadth
        depth
        customFields {
          fieldDefinitionName
          value {
            __typename
            ... on BooleanValue {
              booleanValue: value
            }
            ... on StringValue {
              stringValue: value
            }
            ... on NumberValue {
              numberValue: value
            }
          }
        }
      }
    }
  }
`);

export const GET_PILE_PROPERTIES_QUERY = graphql(`
  query GetPileProperties($id: ID!) {
    pile(id: $id) {
      id
      properties {
        id
        length
        headDiameter
        appointedOn
        embedmentDepth
        customFields {
          fieldDefinitionName
          value {
            __typename
            ... on BooleanValue {
              booleanValue: value
            }
            ... on StringValue {
              stringValue: value
            }
            ... on NumberValue {
              numberValue: value
            }
          }
        }
      }
    }
  }
`);

export const GET_PILE_TIMELINE_QUERY = graphql(`
  query GetPileTimeline($id: ID!) {
    pile(id: $id) {
      id
      inspections {
        id
        inspectionDate
      }
      properties {
        id
        appointedOn
      }
      timeline {
        capacityUtilization
        condition
        eventId
        eventType
      }
    }
  }
`);

export const GET_BOLLARD_TIMELINE_QUERY = graphql(`
  query GetBollardTimeline($id: ID!) {
    bollard(id: $id) {
      id
      inspections {
        id
        inspectionDate
      }
      properties {
        id
        appointedOn
      }
      timeline {
        condition
        eventId
        eventType
        capacityUtilization
      }
    }
  }
`);

export const GET_CAP_BEAM_TIMELINE_QUERY = graphql(`
  query GetCapBeamTimeline($id: ID!) {
    capBeam(id: $id) {
      id
      inspections {
        id
        inspectionDate
      }
      properties {
        id
        appointedOn
      }
      timeline {
        capacityUtilization
        condition
        eventId
        eventType
      }
    }
  }
`);

export const GET_CAP_BEAMS_TABLE_QUERY = graphql(`
  query GetCapBeamsTable {
    capBeams {
      edges {
        node {
          id
          condition
          name
          wharf {
            name
          }
          bent
          rowSpan
          capacityUtilization
          inspectionRequired
          inspections {
            inspectionDate
            inspectedBy {
              firstName
              lastName
            }
          }
        }
      }
    }
  }
`);

export const GET_PILES_TABLE_QUERY = graphql(`
  query GetPilesTable {
    piles {
      edges {
        node {
          id
          condition
          name
          wharf {
            name
          }
          bent
          row
          broken
          side
          capacityUtilization
          inspectionRequired
          inspections {
            wastedDiameter
            seabedDiameter
            inspectionDate
            inspectedBy {
              firstName
              lastName
            }
          }
        }
      }
    }
  }
`);

export const GET_INSPECTION_FREQUENCIES_QUERY = graphql(`
  query GetInspectionFrequencies {
    inspectionFrequencies {
      id
      period
      wharf {
        name
      }
      assetType
    }
  }
`);

export const GET_CAP_BEAMS_GEOGRAPHIC_QUERY = graphql(`
  query GetCapBeamsGeographic {
    capBeams {
      edges {
        node {
          coordinates {
            latitude
            longitude
          }
          id
          condition
          inCommission
          name
          openspaceLink
          inspectionRequired
          capacityUtilization
          side
          rowSpan
          bent
          wharf {
            id
          }
        }
      }
    }
  }
`);

export const GET_PILES_GEOGRAPHIC_QUERY = graphql(`
  query GetPilesGeographic {
    piles {
      edges {
        node {
          id
          coordinates {
            latitude
            longitude
          }
          condition
          inCommission
          name
          openspaceLink
          inspectionRequired
          bent
          capacityUtilization
          side
          row
          wharf {
            id
          }
        }
      }
    }
  }
`);

export const GET_NOTES_QUERY = graphql(`
  query GetNotes($assetId: ID!) {
    notes(assetId: $assetId) {
      id
      postedBy {
        firstName
        lastName
      }
      postedDate
      images
      context
    }
  }
`);

export const DELETE_ASSET_MUTATION = graphql(`
  mutation DeleteAsset($assetId: ID!) {
    deleteAsset(assetId: $assetId)
  }
`);

export const GET_PILES_GEO_EDIT_QUERY = graphql(`
  query GetPilesGeoEdit {
    piles {
      edges {
        node {
          id
          coordinates {
            latitude
            longitude
          }
          inCommission
          name
        }
      }
    }
  }
`);

export const GET_CAP_BEAMS_GEO_EDIT_QUERY = graphql(`
  query GetCapBeamsGeoEdit {
    capBeams {
      edges {
        node {
          coordinates {
            latitude
            longitude
          }
          id
          inCommission
          name
        }
      }
    }
  }
`);

export const GET_CAP_BEAM_DEFAULT_PROPERTIES_QUERY = graphql(`
  query GetCapBeamDefaultProperties {
    capBeamDefaultProperties {
      id
      wharf
      breadth
      depth
    }
  }
`);

export const GET_PILE_DEFAULT_PROPERTIES_QUERY = graphql(`
  query GetPileDefaultProperties {
    pileDefaultProperties {
      id
      length
      row
      wharf
      headDiameter
      embedmentDepth
    }
  }
`);

export const UPDATE_COMMISSION_STATUS_MUTATION = graphql(`
  mutation UpdateCommissionStatus($assetId: ID!, $inCommission: Boolean!) {
    updateCommissionStatus(assetId: $assetId, inCommission: $inCommission)
  }
`);

export const CREATE_BOLLARD_MUTATION = graphql(`
  mutation CreateBollard($input: BollardInput!) {
    createBollard(input: $input) {
      id
    }
  }
`);

export const GET_BOLLARDS_GEOGRAPHIC_QUERY = graphql(`
  query GetBollardsGeographic {
    bollards {
      edges {
        node {
          id
          coordinates {
            latitude
            longitude
          }
          inCommission
          name
          inspectionRequired
          openspaceLink
          condition
          wharf {
            id
          }
        }
      }
    }
  }
`);

export const GET_BOLLARDS_GEO_EDIT_QUERY = graphql(`
  query GetBollardsGeoEdit {
    bollards {
      edges {
        node {
          id
          coordinates {
            latitude
            longitude
          }
          inCommission
          name
        }
      }
    }
  }
`);

export const GET_BOLLARDS_TABLE_QUERY = graphql(`
  query GetBollardsTable {
    bollards {
      edges {
        node {
          id
          name
          wharf {
            name
          }
          inspectionRequired
          condition
          inspections {
            inspectionDate
            inspectedBy {
              firstName
              lastName
            }
          }
        }
      }
    }
  }
`);

export const GET_BOLLARD_INSPECTIONS_QUERY = graphql(`
  query GetBollardInspections($id: ID!) {
    bollard(id: $id) {
      id
      inspections {
        id
        inspectionDate
        inspectedBy {
          firstName
          lastName
        }
        bollardCondition
        groutCondition
        boltsCondition
        undersideLoadPathCondition
        concreteCondition
      }
    }
  }
`);

export const DELETE_BOLLARD_INSPECTION_MUTATION = graphql(`
  mutation DeleteBollardInspection($id: ID!) {
    deleteBollardInspection(id: $id)
  }
`);

export const CREATE_BOLLARD_INSPECTION_MUTATION = graphql(`
  mutation CreateBollardInspection($input: BollardInspectionInput!) {
    createBollardInspection(input: $input) {
      id
      inspectionDate
      inspectedBy {
        firstName
        lastName
      }
    }
  }
`);

export const GET_BOLLARD_PROPERTIES_QUERY = graphql(`
  query GetBollardProperties($id: ID!) {
    bollard(id: $id) {
      id
      properties {
        id
        appointedOn
        bollardKind
        customFields {
          fieldDefinitionName
          value {
            __typename
            ... on BooleanValue {
              booleanValue: value
            }
            ... on StringValue {
              stringValue: value
            }
            ... on NumberValue {
              numberValue: value
            }
          }
        }
      }
    }
  }
`);

export const DELETE_BOLLARD_PROPERTY_MUTATION = graphql(`
  mutation DeleteBollardProperty($id: ID!) {
    deleteBollardProperty(id: $id)
  }
`);

export const CREATE_BOLLARD_PROPERTY_MUTATION = graphql(`
  mutation CreateBollardProperty($input: BollardPropertyInput!) {
    createBollardProperty(input: $input) {
      id
    }
  }
`);

export const GET_BOLLARD_DEFAULT_PROPERTIES_QUERY = graphql(`
  query GetBollardDefaultProperties {
    bollardDefaultProperties {
      id
      wharf {
        name
      }
      bollardKind
    }
  }
`);

export const DELETE_BOLLARD_DEFAULT_PROPERTY_MUTATION = graphql(`
  mutation DeleteBollardDefaultProperty($id: ID!) {
    deleteBollardDefaultProperty(id: $id)
  }
`);

export const CREATE_BOLLARD_DEFAULT_PROPERTY_MUTATION = graphql(`
  mutation NewBollardDefaultProperty($input: BollardDefaultPropertyInput!) {
    createBollardDefaultProperty(input: $input) {
      __typename
      ... on BollardDefaultProperty {
        id
      }
      ... on UserError {
        message
      }
    }
  }
`);

export const GET_ALL_NOTES_QUERY = graphql(`
  query GetAllNotes {
    allNotes {
      note {
        id
        postedBy {
          firstName
          lastName
        }
        postedDate
        images
        context
      }
      asset {
        name
        assetType
      }
    }
  }
`);

export const GET_CUSTOM_FIELD_DEFINITIONS_QUERY = graphql(`
  query GetCustomFieldDefinitions {
    customFieldDefinitions {
      id
      name
      fieldType
      isRequired
      selectOptions
      assetTypes
      createdAt
    }
  }
`);

export const CREATE_CUSTOM_FIELD_DEFINITION_MUTATION = graphql(`
  mutation CreateCustomFieldDefinition($input: CustomFieldDefinitionInput!) {
    createCustomFieldDefinition(input: $input) {
      __typename
      ... on CustomFieldDefinition {
        id
        name
        fieldType
        isRequired
        selectOptions
        assetTypes
        createdAt
      }
      ... on UserError {
        message
      }
    }
  }
`);

export const DELETE_CUSTOM_FIELD_DEFINITION_MUTATION = graphql(`
  mutation DeleteCustomFieldDefinition($id: ID!) {
    deleteCustomFieldDefinition(id: $id)
  }
`);
